import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import "./SchoolStudentCongratulation.css";
import { StudentMapMenuLight } from "../Map/MapMenu/MapMenuLight";
import { useGetQuestChapterDetail } from "../../../../hooks/student/quest/useGetQuestChapterDetail";
import { useAwardStudentCertificate } from "../../../../hooks/student/certificate/useAwardStudentCertificate";
import { useAwardStudentTrophy } from "../../../../hooks/student/trophy/useAwardStudentTrophy";

export const SchlStudentAdminCongo = () => {
  const { questId, chapterId } = useParams();
  const [quizResultData, setQuizResultData] = useState(null);
  const { questChapterDetail, getStudentQuestChapterDetail } =
    useGetQuestChapterDetail();
  const { awardStudentCertificate } = useAwardStudentCertificate();
  const { awardStudentTrophy } = useAwardStudentTrophy();

  useEffect(() => {
    const apiData = sessionStorage.getItem("quizProgressApiResponse");
    if (apiData) {
      setQuizResultData(JSON.parse(apiData));
    }
  }, []);

  const quizTotalQuestions = quizResultData?.attempt?.meta?.total || 0;
  const quizCorrectAnswers = quizResultData?.attempt?.meta?.correct || 0;
  const quizzStudentIsPassed = quizResultData?.attempt?.is_passed || false;
  const questType = localStorage.getItem("quiz_type");

  // const clearQuizSession = () => {
  //   sessionStorage.removeItem("quizProgressApiResponse");
  // };

  useEffect(() => {
    if (!chapterId) return;
    getStudentQuestChapterDetail(chapterId);
  }, [chapterId]);

  useEffect(() => {
    if (!quizzStudentIsPassed) return;

    try {
      awardStudentCertificate({
        quest_id: Number(questId),
        chapter_id: Number(chapterId),
      });
    } catch (error) {
      console.log(error);
    }
  }, [quizzStudentIsPassed, questId, chapterId]);

  useEffect(() => {
    if (!quizzStudentIsPassed || questChapterDetail?.next_chapter !== null)
      return;

    try {
      awardStudentTrophy({
        quest_id: Number(questId),
      });
    } catch (error) {
      console.log(error);
    }
  }, [questChapterDetail?.next_chapter, questId]);

  return (
    <>
      <section className="SchlStdntCongoBg">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-2">
              <div className="SchlStdntCongoLftIcns">
                <img
                  className="w-auto"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/Group+163740.png"
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-8 d-flex justify-content-center align-items-center min-vh-100">
              <div
                style={{
                  background: "#0000A5",
                  background:
                    "linear-gradient(230deg, rgba(0, 0, 165, 1) 0%, rgba(0, 0, 73, 1) 85%)",
                  border: "2px solid #00F9FF",
                  borderRadius: "20px",
                  padding: "50px 20px",
                  position: "relative",
                  width: "90%",
                  zIndex: 2,
                }}
                className="d-flex justify-content-center align-items-center text-center"
              >
                <div className="SchlStdntCongohnumnIcn">
                  <img
                    className="img-fluid"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/FRONT+2.png"
                    alt=""
                  />
                </div>

                <div className="SchlStdntCongoShivIcn">
                  <img
                    className="img-fluid"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/Asset+2%403x+1.png"
                    alt=""
                  />
                </div>

                <div>
                  <div>
                    {quizzStudentIsPassed === false ? (
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/try+again+1.png"
                        alt="Great Job"
                        className="img-fluid mb-3"
                        style={{
                          maxWidth: "80%", // or 100%, depending on the layout
                          height: "auto", // maintains aspect ratio
                        }}
                      />
                    ) : quizCorrectAnswers === quizTotalQuestions ? (
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/welcome+1.png"
                        alt="Great Job"
                        className="img-fluid mb-3"
                        style={{
                          maxWidth: "80%", // or 100%, depending on the layout
                          height: "auto", // maintains aspect ratio
                        }}
                      />
                    ) : (
                      <img
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/you+did+it+1.png"
                        alt="Great Job"
                        className="img-fluid mb-3"
                        style={{
                          maxWidth: "80%", // or 100%, depending on the layout
                          height: "auto", // maintains aspect ratio
                        }}
                      />
                    )}

                    <p className="SchlStdntCongoScoreTab">
                      {/* you have unloacked a new quest certificate */}
                      YOU GOT{" "}
                      <span
                        style={{
                          color: "#F9C430",
                          fontSize: 30,
                          fontWeight: 500,
                          paddingLeft: 10,
                          paddingRight: 10,
                        }}
                      >
                        {quizCorrectAnswers}/{quizTotalQuestions}
                      </span>{" "}
                      QUESTIONS CORRECT!
                    </p>
                    {quizCorrectAnswers === quizTotalQuestions ? null : (
                      <p className="SchlStdntCongoAchveTxt">
                        Achieve Higher Marks
                      </p>
                    )}
                    <div className="SchlStdntCongoKishnIcn">
                      <img
                        className="img-fluid"
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/K+copy+1+(1).png"
                        alt=""
                      />
                    </div>
                    <div className="SchlStdntCongoLoadIcn">
                      <img
                        className="img-fluid"
                        src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/Group.png"
                        alt=""
                      />
                    </div>
                    <div style={{ marginTop: "20px" }}>
                      {quizzStudentIsPassed === true ? (
                        <>
                          {quizCorrectAnswers === quizTotalQuestions ? null : (
                            <Link
                              to={`/student/admin/quiz/${questChapterDetail?.chapter?.questID}/${chapterId}`}
                            >
                              <img
                                className="SchlStdntCongoActnIcn"
                                src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/Group+163751.png"
                                alt=""
                              />
                            </Link>
                          )}

                          {questType === "festive" ? null : (
                            <Link
                              to={`/student/admin/certificates/${questChapterDetail?.chapter?.questID}`}
                              style={{
                                background:
                                  "linear-gradient(172.64deg, #FDC526 4.73%, #FF9203 93.58%)",
                                color: "#050505",
                                borderRadius: "40px",
                                padding: "10px 40px",
                                fontSize: "18px",
                                fontWeight: "400",
                                display: "inline-block",
                                marginLeft: 20,
                                marginRight: 20,
                              }}
                            >
                              View Certificate
                            </Link>
                          )}

                          {questChapterDetail?.next_chapter === null ? (
                            <Link
                              to={`/student/admin/trophy`}
                              style={{
                                background:
                                  "linear-gradient(172.64deg, #FDC526 4.73%, #FF9203 93.58%)",
                                color: "#050505",
                                borderRadius: "40px",
                                padding: "10px 40px",
                                fontSize: "18px",
                                fontWeight: "400",
                                display: "inline-block",
                                marginLeft: 20,
                                marginRight: 20,
                              }}
                            >
                              View Trophy
                            </Link>
                          ) : null}

                          {questChapterDetail?.next_chapter === null ? null : (
                            <Link
                              to={
                                questChapterDetail?.next_chapter === null
                                  ? `/student/admin/certificates/${questChapterDetail?.chapter?.questID}`
                                  : `/student/admin/episodes/detail/${questId}/${questChapterDetail?.next_chapter.id}`
                              }
                            >
                              <img
                                className="SchlStdntCongoActnIcn"
                                src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/Group+163752.png"
                                alt=""
                              />
                            </Link>
                          )}
                        </>
                      ) : (
                        <Link
                          to={`/student/admin/quiz/${questChapterDetail?.chapter?.questID}/${chapterId}`}
                        >
                          <img
                            className="SchlStdntCongoActnIcn"
                            src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/Group+163751.png"
                            alt=""
                          />
                        </Link>
                      )}
                    </div>
                    {/* <div style={{ marginTop: "20px" }}>
                      <Link
                        style={{
                          background:
                            "linear-gradient(172.64deg, #FDC526 4.73%, #FF9203 93.58%)",
                          color: "#333333",
                          borderRadius: "40px",
                          padding: "10px 30px",
                          fontSize: "14px",
                          fontWeight: "600",
                          display: "inline-block",
                        }}
                        to={
                          questChapterData?.next_chapter === null
                            ? `/student/admin/certificates/${questChapterData?.chapter?.questID}`
                            : `/student/admin/episodes/detail/${questId}/${questChapterData?.next_chapter.id}`
                        }
                      >
                        {questChapterData?.next_chapter !== null
                          ? "Next Episode"
                          : "Go to Certificates"}
                      </Link>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div
                className="SchlStdntCongoRgtIcns"
                style={{ position: "relative", zIndex: 4 }}
              >
                <img
                  className="w-auto"
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/schoolStudent/Group+163739.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          {/* Footer with highest z-index */}
          <div style={{ position: "relative", zIndex: 4 }}>
            <StudentMapMenuLight />
          </div>
        </div>
      </section>
    </>
  );
};
